/** `integration` module backend checkers for DTOs */
export enum IntegrationCheckersEnum {
  /** Check whether 1C ERP database connection(s) exist by received unique ID(s) */
  CONNECTION_1C_ASSERT_EXISTS_BY_ID = 'integration/connection-1c-assert-exists-by-id',
  /** Check whether 1C ERP database connection(s) exist by received DTO(s) with unique ID(s) */
  CONNECTION_1C_ASSERT_EXISTS_BY_DTO = 'integration/connection-1c-assert-exists-by-dto',
  /** Check whether email(s) exist by received unique ID(s) */
  EMAIL_ASSERT_EXISTS_BY_ID = 'integration/email-assert-exists-by-id',
  /** Check whether email(s) exist by received DTO(s) with unique ID(s) */
  EMAIL_ASSERT_EXISTS_BY_DTO = 'integration/email-assert-exists-by-dto',
  /** Check whether MainSMS account(s) exist by received unique ID(s) */
  MAIN_SMS_ACCOUNT_ASSERT_EXISTS_BY_ID = 'integration/main-sms-account-assert-exists-by-id',
  /** Check whether MainSMS account(s) exist by received DTO(s) with unique ID(s) */
  MAIN_SMS_ACCOUNT_ASSERT_EXISTS_BY_DTO = 'integration/main-sms-account-assert-exists-by-dto',
}
